import { Container } from '@/components/Container';
import { getPublished } from '@/data/loader';
import { WhatsAppButton } from '@/components/WhatsAppButton';
import { useTranslation } from '@/hooks/useTranslation';

/* ═══════════════════════════════════════════
   ROTEIROS — Dia a dia com dados reais
   Baseado em conteudo.md + JSON loader
   ═══════════════════════════════════════════ */

interface Dia {
  periodo: string;
  atividade: string;
  descricao: string;
  distancia?: string;
  tempo?: string;
}

interface Roteiro {
  nome: string;
  subtitulo: string;
  dias: Dia[][];
  custo: string;
  cor: string;
  corBg: string;
  corTexto: string;
}

export function RoteirosSection() {
  const { t } = useTranslation();
  const passeios = getPublished('passeio');
  const passeio360 = passeios.find((p: any) => p.handle === 'passeio-360');
  const batismoVela = passeios.find((p: any) => p.handle === 'batismo-vela');

  const roteiros: Roteiro[] = [
    {
      nome: t('guide.roteiros.r1.name'),
      subtitulo: t('guide.roteiros.r1.subtitle'),
      custo: t('guide.roteiros.r1.custo'),
      cor: 'border-sand-300',
      corBg: 'bg-sand-50',
      corTexto: 'text-warm-dark',
      dias: [
        [
          {
            periodo: t('guide.roteiros.r1.d0.i0.periodo'),
            atividade: t('guide.roteiros.r1.d0.i0.atividade'),
            descricao: t('guide.roteiros.r1.d0.i0.descricao'),
            tempo: t('guide.roteiros.r1.d0.i0.tempo'),
          },
          {
            periodo: t('guide.roteiros.r1.d0.i1.periodo'),
            atividade: t('guide.roteiros.r1.d0.i1.atividade'),
            descricao: t('guide.roteiros.r1.d0.i1.descricao'),
            distancia: t('guide.roteiros.r1.d0.i1.distancia'),
            tempo: t('guide.roteiros.r1.d0.i1.tempo'),
          },
          {
            periodo: t('guide.roteiros.r1.d0.i2.periodo'),
            atividade: t('guide.roteiros.r1.d0.i2.atividade'),
            descricao: t('guide.roteiros.r1.d0.i2.descricao'),
            distancia: t('guide.roteiros.r1.d0.i2.distancia'),
            tempo: t('guide.roteiros.r1.d0.i2.tempo'),
          },
          {
            periodo: t('guide.roteiros.r1.d0.i3.periodo'),
            atividade: t('guide.roteiros.r1.d0.i3.atividade'),
            descricao: t('guide.roteiros.r1.d0.i3.descricao'),
          },
          {
            periodo: t('guide.roteiros.r1.d0.i4.periodo'),
            atividade: t('guide.roteiros.r1.d0.i4.atividade'),
            descricao: t('guide.roteiros.r1.d0.i4.descricao'),
            distancia: t('guide.roteiros.r1.d0.i4.distancia'),
            tempo: t('guide.roteiros.r1.d0.i4.tempo'),
          },
          {
            periodo: t('guide.roteiros.r1.d0.i5.periodo'),
            atividade: t('guide.roteiros.r1.d0.i5.atividade'),
            descricao: t('guide.roteiros.r1.d0.i5.descricao'),
          },
        ],
      ],
    },
    {
      nome: t('guide.roteiros.r2.name'),
      subtitulo: t('guide.roteiros.r2.subtitle'),
      custo: t('guide.roteiros.r2.custo'),
      cor: 'border-teal-300',
      corBg: 'bg-teal-50',
      corTexto: 'text-teal-700',
      dias: [
        [
          {
            periodo: t('guide.roteiros.r2.d0.i0.periodo'),
            atividade: t('guide.roteiros.r2.d0.i0.atividade'),
            descricao: t('guide.roteiros.r2.d0.i0.descricao'),
            distancia: t('guide.roteiros.r2.d0.i0.distancia'),
            tempo: t('guide.roteiros.r2.d0.i0.tempo'),
          },
          {
            periodo: t('guide.roteiros.r2.d0.i1.periodo'),
            atividade: t('guide.roteiros.r2.d0.i1.atividade'),
            descricao: t('guide.roteiros.r2.d0.i1.descricao'),
            distancia: t('guide.roteiros.r2.d0.i1.distancia'),
            tempo: t('guide.roteiros.r2.d0.i1.tempo'),
          },
          {
            periodo: t('guide.roteiros.r2.d0.i2.periodo'),
            atividade: t('guide.roteiros.r2.d0.i2.atividade'),
            descricao: t('guide.roteiros.r2.d0.i2.descricao'),
          },
        ],
        [
          {
            periodo: t('guide.roteiros.r2.d1.i0.periodo'),
            atividade: t('guide.roteiros.r2.d1.i0.atividade'),
            descricao: t('guide.roteiros.r2.d1.i0.descricao'),
            distancia: t('guide.roteiros.r2.d1.i0.distancia'),
            tempo: t('guide.roteiros.r2.d1.i0.tempo'),
          },
          {
            periodo: t('guide.roteiros.r2.d1.i1.periodo'),
            atividade: t('guide.roteiros.r2.d1.i1.atividade'),
            descricao: t('guide.roteiros.r2.d1.i1.descricao'),
            distancia: t('guide.roteiros.r2.d1.i1.distancia'),
            tempo: t('guide.roteiros.r2.d1.i1.tempo'),
          },
          {
            periodo: t('guide.roteiros.r2.d1.i2.periodo'),
            atividade: t('guide.roteiros.r2.d1.i2.atividade'),
            descricao: t('guide.roteiros.r2.d1.i2.descricao'),
          },
        ],
      ],
    },
    {
      nome: t('guide.roteiros.r3.name'),
      subtitulo: t('guide.roteiros.r3.subtitle'),
      custo: t('guide.roteiros.r3.custo'),
      cor: 'border-amber-300',
      corBg: 'bg-amber-50',
      corTexto: 'text-amber-700',
      dias: [
        [
          {
            periodo: t('guide.roteiros.r3.d0.i0.periodo'),
            atividade: t('guide.roteiros.r3.d0.i0.atividade'),
            descricao: t('guide.roteiros.r3.d0.i0.descricao'),
            distancia: t('guide.roteiros.r3.d0.i0.distancia'),
            tempo: t('guide.roteiros.r3.d0.i0.tempo'),
          },
          {
            periodo: t('guide.roteiros.r3.d0.i1.periodo'),
            atividade: t('guide.roteiros.r3.d0.i1.atividade'),
            descricao: t('guide.roteiros.r3.d0.i1.descricao'),
            distancia: t('guide.roteiros.r3.d0.i1.distancia'),
            tempo: t('guide.roteiros.r3.d0.i1.tempo'),
          },
          {
            periodo: t('guide.roteiros.r3.d0.i2.periodo'),
            atividade: t('guide.roteiros.r3.d0.i2.atividade'),
            descricao: t('guide.roteiros.r3.d0.i2.descricao'),
          },
        ],
        [
          {
            periodo: t('guide.roteiros.r3.d1.i0.periodo'),
            atividade: t('guide.roteiros.r3.d1.i0.atividade'),
            descricao: t('guide.roteiros.r3.d1.i0.descricao'),
            distancia: t('guide.roteiros.r3.d1.i0.distancia'),
            tempo: t('guide.roteiros.r3.d1.i0.tempo'),
          },
          {
            periodo: t('guide.roteiros.r3.d1.i1.periodo'),
            atividade: t('guide.roteiros.r3.d1.i1.atividade'),
            descricao: t('guide.roteiros.r3.d1.i1.descricao'),
            distancia: t('guide.roteiros.r3.d1.i1.distancia'),
            tempo: t('guide.roteiros.r3.d1.i1.tempo'),
          },
          {
            periodo: t('guide.roteiros.r3.d1.i2.periodo'),
            atividade: t('guide.roteiros.r3.d1.i2.atividade'),
            descricao: t('guide.roteiros.r3.d1.i2.descricao'),
          },
        ],
        [
          {
            periodo: t('guide.roteiros.r3.d2.i0.periodo'),
            atividade: t('guide.roteiros.r3.d2.i0.atividade'),
            descricao: t('guide.roteiros.r3.d2.i0.descricao'),
            distancia: t('guide.roteiros.r3.d2.i0.distancia'),
            tempo: t('guide.roteiros.r3.d2.i0.tempo'),
          },
          {
            periodo: t('guide.roteiros.r3.d2.i1.periodo'),
            atividade: t('guide.roteiros.r3.d2.i1.atividade'),
            descricao: t('guide.roteiros.r3.d2.i1.descricao'),
            distancia: t('guide.roteiros.r3.d2.i1.distancia'),
            tempo: t('guide.roteiros.r3.d2.i1.tempo'),
          },
          {
            periodo: t('guide.roteiros.r3.d2.i2.periodo'),
            atividade: t('guide.roteiros.r3.d2.i2.atividade'),
            descricao: t('guide.roteiros.r3.d2.i2.descricao'),
            tempo: t('guide.roteiros.r3.d2.i2.tempo'),
          },
        ],
      ],
    },
  ];

  return (
    <section id="roteiros" className="py-16 sm:py-20 bg-sand-50">
      <Container>
        {/* Header */}
        <div className="text-center mb-12">
          <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
            {t('guide.roteiros.overline')}
          </span>
          <h2 className="font-display text-4xl sm:text-5xl text-warm-dark mt-2">
            {t('guide.roteiros.title')}
          </h2>
          <p className="font-editorial text-lg text-warm-gray mt-2 max-w-2xl mx-auto">
            {t('guide.roteiros.subtitle')}
          </p>
        </div>

        {/* Abas de roteiro */}
        <div className="space-y-8">
          {roteiros.map(r => (
            <div
              key={r.nome}
              className={`rounded-2xl border-2 ${r.cor} ${r.corBg} overflow-hidden`}
            >
              {/* Header do roteiro */}
              <div className="p-6 sm:p-8 border-b border-sand-200">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  <div>
                    <div className="flex items-center gap-3 mb-2">
                      <span className="font-display text-4xl text-warm-dark">{r.nome}</span>
                      <span
                        className={`font-body text-sm font-bold ${r.corTexto} bg-white px-3 py-1 rounded-full border border-sand-200`}
                      >
                        {r.custo}
                      </span>
                    </div>
                    <p className="font-body text-warm-gray">{r.subtitulo}</p>
                  </div>
                </div>
              </div>

              {/* Dias */}
              <div className="p-6 sm:p-8 space-y-8">
                {r.dias.map((dia, diaIndex) => (
                  <div key={diaIndex}>
                    {r.dias.length > 1 && (
                      <h4 className="font-display text-lg text-warm-dark mb-4">
                        {t('guide.roteiros.dayLabel').replace('{{n}}', String(diaIndex + 1))}
                      </h4>
                    )}
                    <div className="space-y-4">
                      {dia.map((item, itemIndex) => (
                        <div
                          key={itemIndex}
                          className="bg-white rounded-xl border border-sand-200 p-4 flex flex-col sm:flex-row sm:items-start gap-3"
                        >
                          <div className="flex-shrink-0 w-20">
                            <span className="font-body text-xs font-bold text-teal-deep uppercase">
                              {item.periodo}
                            </span>
                          </div>
                          <div className="flex-1">
                            <h4 className="font-display text-base text-warm-dark mb-1">
                              {item.atividade.toUpperCase()}
                            </h4>
                            <p className="font-body text-sm text-warm-gray mb-2">
                              {item.descricao}
                            </p>
                            <div className="flex flex-wrap gap-x-4 gap-y-1">
                              {item.distancia && (
                                <span className="font-body text-xs text-teal-deep bg-teal-50 px-2 py-0.5 rounded-full">
                                  {t('guide.roteiros.distanceLabel').replace(
                                    '{{dist}}',
                                    item.distancia
                                  )}
                                </span>
                              )}
                              {item.tempo && (
                                <span className="font-body text-xs text-amber-600 bg-amber-50 px-2 py-0.5 rounded-full">
                                  {t('guide.roteiros.timeLabel').replace('{{tempo}}', item.tempo)}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* CTAs Parceiros */}
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {passeio360 && (
            <div className="bg-teal-deep rounded-2xl p-6 sm:p-8 text-white">
              <div className="flex flex-col gap-6">
                <div>
                  <span className="font-body text-xs uppercase tracking-wider text-teal-200 mb-1 block">
                    {t('guide.roteiros.ctaPartnerBadge', 'Parceiro')}
                  </span>
                  <h3 className="font-display text-2xl mb-2">{t('guide.roteiros.ctaTitle')}</h3>
                  <p className="font-body text-white/80">{t('guide.roteiros.ctaDesc')}</p>
                </div>
                <div className="flex-shrink-0">
                  <div className="text-center mb-3">
                    <span className="font-display text-3xl text-coral">
                      R$ {passeio360.price?.amount}
                    </span>
                    <span className="font-body text-sm text-white/70">
                      / {passeio360.price?.unit}
                    </span>
                  </div>
                  {passeio360.provider && (
                    <WhatsAppButton
                      provider={passeio360.provider}
                      source="guia-roteiros"
                      label={t('guide.roteiros.bookButton')}
                      variant="button"
                      className="bg-coral hover:bg-[#c96a52] w-full justify-center"
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          {batismoVela && (
            <div className="bg-ocean rounded-2xl p-6 sm:p-8 text-white">
              <div className="flex flex-col gap-6">
                <div>
                  <span className="font-body text-xs uppercase tracking-wider text-ocean-200 mb-1 block">
                    {t('guide.roteiros.ctaPartnerBadge', 'Parceiro')}
                  </span>
                  <h3 className="font-display text-2xl mb-2">
                    {t('guide.roteiros.velaTitle', 'BATISMO DE VELA')}
                  </h3>
                  <p className="font-body text-white/80">
                    {t('guide.roteiros.velaDesc', 'Aula de vela de 2h com o Luiz no trapiche de Encantadas. Para iniciantes, crianças e adultos.')}
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <div className="text-center mb-3">
                    <span className="font-display text-3xl text-coral">
                      R$ {batismoVela.price?.amount}
                    </span>
                    <span className="font-body text-sm text-white/70">
                      / {batismoVela.price?.unit}
                    </span>
                  </div>
                  {batismoVela.provider && (
                    <WhatsAppButton
                      provider={batismoVela.provider}
                      source="guia-roteiros-vela"
                      label={t('guide.roteiros.bookButton')}
                      variant="button"
                      className="bg-coral hover:bg-[#c96a52] w-full justify-center"
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </Container>
    </section>
  );
}
